"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userProfileInputSchema = exports.userMobilePhoneSchema = exports.userLastNameSchema = exports.userFirstNameSchema = void 0;
const zod_1 = require("zod");
exports.userFirstNameSchema = zod_1.z.string().trim().min(1).max(60);
exports.userLastNameSchema = zod_1.z.string().trim().min(1).max(59);
exports.userMobilePhoneSchema = zod_1.z.preprocess((value) => typeof value === "string" && value.trim().length === 0 ? null : value, zod_1.z.string().trim().min(7).max(40).nullable());
exports.userProfileInputSchema = zod_1.z.object({
    firstName: exports.userFirstNameSchema,
    lastName: exports.userLastNameSchema,
    mobilePhone: exports.userMobilePhoneSchema,
});
//# sourceMappingURL=user-profile.js.map